import { travelTypeObject } from '../../enumeration';
import { PATH_DASHBOARD } from '../../routes/paths';
import api from '../../services/api';

const EagentRole = {
  title: {
    name: ['سمت', 'سمت ها'],
  },
  routes: PATH_DASHBOARD.agentRole,
  api: api.agentRole,
  enum: {
    array: Object.values(travelTypeObject),
    object: travelTypeObject,
  },
};

export default EagentRole;
